import React from 'react'
import CSSTransition from 'react-transition-group/CSSTransition'
import ModalContent from './ModalContent'

const AnimatedModal = ({ duration = 300, open, children }) => {
  return (
    <CSSTransition in={open} timeout={duration} classNames='fade' unmountOnExit>
      <ModalContent>{children}</ModalContent>
    </CSSTransition>
  )
}

export default AnimatedModal
